import ReviewableSetting from 'automation-ui-canvas/containers/review/ReviewableSetting';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UIList from 'UIComponents/list/UIList';
import Small from 'UIComponents/elements/Small';
import formatShortDate from 'I18n/utils/formatShortDate';
import { toNumber } from 'automation-ui-canvas/flow/constants/DisplayMonth';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TimingReviewableSetting = ({
  flow
}) => {
  var _flow$getTimeWindow, _flow$getTimeWindow2, _flow$getTimeWindow3, _flow$getTimeWindow$g, _flow$getTimeWindow4, _flow$getTimeWindow5, _flow$getTimeWindow$g2, _flow$getTimeWindow6;
  const isActionTimingEnabled = ((_flow$getTimeWindow = flow.getTimeWindow()) === null || _flow$getTimeWindow === void 0 || (_flow$getTimeWindow = _flow$getTimeWindow.getTimeRanges()) === null || _flow$getTimeWindow === void 0 ? void 0 : _flow$getTimeWindow.size) || ((_flow$getTimeWindow2 = flow.getTimeWindow()) === null || _flow$getTimeWindow2 === void 0 || (_flow$getTimeWindow2 = _flow$getTimeWindow2.getFutureBlockedDates()) === null || _flow$getTimeWindow2 === void 0 ? void 0 : _flow$getTimeWindow2.size) || flow.getScheduledDisableAt();
  const runSection = (!!((_flow$getTimeWindow3 = flow.getTimeWindow()) !== null && _flow$getTimeWindow3 !== void 0 && (_flow$getTimeWindow3 = _flow$getTimeWindow3.getTimeRanges()) !== null && _flow$getTimeWindow3 !== void 0 && _flow$getTimeWindow3.size) || !!flow.getScheduledDisableAt()) && /*#__PURE__*/_jsxs("div", {
    className: "m-bottom-3",
    children: [/*#__PURE__*/_jsx(Small, {
      tagName: "b",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.settingsStep.setting.run"
      })
    }), /*#__PURE__*/_jsxs(UIList, {
      children: [((_flow$getTimeWindow$g = (_flow$getTimeWindow4 = flow.getTimeWindow()) === null || _flow$getTimeWindow4 === void 0 ? void 0 : _flow$getTimeWindow4.getTimeRanges()) !== null && _flow$getTimeWindow$g !== void 0 ? _flow$getTimeWindow$g : []).map((timeRange, idx) => {
        const dayOfWeek = I18n.text(`automation.common.daysOfWeek.${timeRange.getDay()}`);
        const startTime = I18n.moment().hours(0).seconds(0).minutes(timeRange.getStartTimeInMinutes()).format('LT');
        const endTime = I18n.moment().hours(0).seconds(0).minutes(timeRange.getEndTimeInMinutes()).format('LT');
        return /*#__PURE__*/_jsx(Small, {
          tagName: "span",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformReview.v2.settingsStep.setting.runAt",
            options: {
              startTime,
              endTime,
              dayOfWeek
            }
          })
        }, idx);
      }), flow.getScheduledDisableAt() && /*#__PURE__*/_jsx(Small, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformReview.v2.settingsStep.setting.runUntil",
          options: {
            date: I18n.moment(flow.getScheduledDisableAt()).format('lll')
          }
        })
      })]
    })]
  });
  const dontRunSection = !!((_flow$getTimeWindow5 = flow.getTimeWindow()) !== null && _flow$getTimeWindow5 !== void 0 && (_flow$getTimeWindow5 = _flow$getTimeWindow5.getFutureBlockedDates()) !== null && _flow$getTimeWindow5 !== void 0 && _flow$getTimeWindow5.size) && /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Small, {
      tagName: "b",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "platformReview.v2.settingsStep.setting.doNotRun"
      })
    }), /*#__PURE__*/_jsx(UIList, {
      children: ((_flow$getTimeWindow$g2 = (_flow$getTimeWindow6 = flow.getTimeWindow()) === null || _flow$getTimeWindow6 === void 0 ? void 0 : _flow$getTimeWindow6.getFutureBlockedDates()) !== null && _flow$getTimeWindow$g2 !== void 0 ? _flow$getTimeWindow$g2 : []).map((blockedDateMetadata, idx) => {
        const moment = I18n.moment().utc().date(blockedDateMetadata.dayOfMonth).month(toNumber(blockedDateMetadata.month)).year(blockedDateMetadata.year);
        if (blockedDateMetadata.type === 'STATIC_DATE') {
          return /*#__PURE__*/_jsx(Small, {
            tagName: "span",
            children: moment.format('ll')
          }, idx);
        }
        return /*#__PURE__*/_jsx(Small, {
          tagName: "span",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "platformReview.v2.settingsStep.setting.doNotRunAt",
            options: {
              date: formatShortDate(moment, 'portalTz'),
              year: moment.format('YYYY')
            }
          })
        }, idx);
      })
    })]
  });
  return /*#__PURE__*/_jsx(ReviewableSetting, {
    settingName: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "platformReview.v2.settingsStep.setting.actionSchedule"
    }),
    settingValue: Boolean(isActionTimingEnabled),
    description: isActionTimingEnabled ? /*#__PURE__*/_jsxs("div", {
      children: [runSection, dontRunSection]
    }) : undefined,
    settingSectionId: "general"
  });
};
export default TimingReviewableSetting;